export default {
  isNotEmpty (value) {
    return typeof value === 'boolean' || typeof value === 'number' || !!value
  },
  isEmail (value) {
    const regexMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regexMail.test(value)
  },
  isNumberFormat (value) {
    const regex = /^[0-9]+$/
    return regex.test(value)
  },
  isAlphabetAndSpaceFormat (value) {
    const regex = /^[a-zA-Z ]*$/
    return regex.test(value)
  },
  isAlphaNumericFormat (value) {
    const regex = /^(?=.{7,})(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/
    return regex.test(value)
  },
  isAlphaNumericAndSomeSymbolicFormat (value) {
    const regex = /^[a-zA-Z\d\-,.\s]+$/i
    return regex.test(value)
  },
  isAlphaNumericAndSymbolicFormat (value) {
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$&_\-=+,.?[\]{}])[A-Za-z\d!@#$&_\-=+,.?[\]{}]{8,}$/
    return regex.test(value)
  },
  isNoSpaceOnFirstAndLastChar (value) {
    const regex = /^[^\s]+(\s+[^\s]+)*$/
    return regex.test(value)
  },
  isDoubleSpaceBetweenChar (value) {
    const regex = /\s{2,}/
    return regex.test(value)
  },
  forbiddenFileNameCharacter (value) {
    const regex = /[<>"/\\';:{}]/
    return regex.test(value)
  },
  isTooShort (value, min = 0) {
    const currLength = value.length

    if (currLength === 0) return
    return currLength < min
  },
  isTooMany (value, max = 0) {
    const currLength = value.length

    if (currLength === 0) return
    return currLength > max
  },
  isFixLength (value, min = 0, max = 0) {
    const currLength = value.length

    if (currLength === 0 || min !== max) return
    return currLength === min
  },
  inputAmountFormat (value) {
    return String(value).replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  },
  inputNumberFormat (value) {
    return String(value).replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '')
  },
  inputAlphabetFormat (value) {
    return String(value).replace(/\d+/g, '')
  },
  sanitizeInputSpecialCharacters (blacklistSpecialCharacters, value) {
    const regexPattern = new RegExp(`[${blacklistSpecialCharacters}]`, 'g')
    return String(value).replace(regexPattern, '')
  },
  blockTypeSpecialCharacters (evt) {
    const k = evt.which || evt.keyCode
    let capitalAlphabets = (k > 64 && k < 91)
    let alphabets = (k > 96 && k < 123)
    let backSpace = k === 8
    let space = k === 32
    let comma = k === 44
    let enter = k === 13
    let dotAndNumbers = (k >= 46 && k <= 57)
    let apostrophe = k === 39
    let underScore = k === 95
    let doubleQuotes = k === 34
    let hypen = k === 45
    let colon = k === 58
    let paranthesis = k === 40 || k === 41
    let asteric = k === 42
    let plus = k === 43

    let isColonAllowed = false

    if (colon) {
      isColonAllowed = this.handleTypeColonCharacter(evt)
    }

    let allowedSpecialChars = backSpace || space || comma || enter || apostrophe || underScore || doubleQuotes || hypen ||
    isColonAllowed || asteric || paranthesis || plus

    if (capitalAlphabets || alphabets || dotAndNumbers || allowedSpecialChars) {
      return true
    }
    evt.preventDefault()
    return false
  },
  blockTypeBlacklistCharacters (blacklistCharacters, evt) {
    const k = evt.type === 'paste' ? evt.clipboardData.getData('text') : evt.key
    const regexPattern = new RegExp(`[${blacklistCharacters}]`, 'g')
    const match = regexPattern.test(k)
    if (match) {
      evt.preventDefault()
      return false
    }
    return true
  },
  blockPasteSpecialCharacters (evt) {
    if (evt && evt.clipboardData && evt.clipboardData.getData('text')) {
      const pastedText = evt.clipboardData.getData('text')
      const isColonAllowed = this.validateColonSentences(evt, pastedText)
      const regEx = /^[A-Za-z0-9 ,._'-/":()*+(\r\n|\r|\n)]+$/
      if (regEx.test(pastedText) && isColonAllowed) return true
    }
    evt.preventDefault()
    return false
  },
  blockPasteNumericalOnly (evt) {
    if (evt && evt.clipboardData && evt.clipboardData.getData('text')) {
      let pastedText = evt.clipboardData.getData('text')
      const regEx = /^[0-9]*$/gm
      if (regEx.test(pastedText)) return true
    }
    evt.preventDefault()
    return false
  },
  handleStringTypeLength (evt, maxLength) {
    if (evt && evt.target && evt.target.value.length <= maxLength) {
      return true
    }
    evt.preventDefault()
    return false
  },
  handleStringPasteLength (evt, maxLength) {
    if (evt && evt.clipboardData && evt.clipboardData.getData('text')) {
      const existingTextLength = evt.target ? evt.target.value.length : 0
      const pastedText = evt.clipboardData.getData('text')
      const pastedTextLength = pastedText ? pastedText.length : 0
      if (existingTextLength + pastedTextLength <= maxLength) return true
    }
    evt.preventDefault()
    return false
  },
  handleTypeColonCharacter (evt) {
    if (evt && evt.target) {
    let eventText = evt.target.value
      if (eventText.length) {
        let last10Characters = eventText.slice(-10)
        let last6Characters = eventText.slice(-6)
        let last5Characters = eventText.slice(-5)
        let last4Characters = eventText.slice(-4)

        let reg10Ex = new RegExp(/javascript/gi)

        let reg6Ex = new RegExp(/script/gi)

        let filter5Strings = ['image', 'https', 'width']

        let reg5Ex = new RegExp(filter5Strings.join('|'), 'gi')

        let reg4Ex = new RegExp(/http/gi)

        if (reg10Ex.test(last10Characters) || reg6Ex.test(last6Characters) || reg5Ex.test(last5Characters) || reg4Ex.test(last4Characters)) {
            return false
        }
      }
    }
    return true
  },
  validateColonSentences (evt, sentence) {
    let textValue = sentence || (evt && evt.target && evt.target.value)
    if (textValue) {
      let regEx = /(?:javascript:|https:|http:|script:|image:|width:)/gi
      if (regEx.test(textValue)) {
          return false
      }
    }
    return true
  },
  isContainingForbiddenWords (message, forbiddenWords) {
    if (!forbiddenWords.length) { return }
    const pattern = new RegExp(forbiddenWords.join('|'), 'i')
    const match = pattern.test(message)
    return match
  },
  isUrl (value) {
    const regexUrl = /^(https?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.)[0-9A-Za-z-.\:@%_+~#=]+(\.[a-zA-Z]{2,3})+(\/.*)?(\?.*)?$/
    return regexUrl.test(value)
  },
  isYoutubeUrl (value, regex) {
    const regexUrl = new RegExp(regex)
    return regexUrl.test(value)
  },
  handleWhitelistLimitXss (limitXss, evt) {
    const k = evt.type === 'paste' ? evt.clipboardData.getData('text') : evt.key
    const regexPattern = new RegExp(limitXss, 'g')
    const match = regexPattern.test(k)
    if (!match) {
      evt.preventDefault()
    }
    return match
  }
}
